var swiper = new Swiper(".membershipsContainer", {
  slidesPerView: 2.65,
  slidesPerGroup: 2,
  spaceBetween: 20,
  grid: {
    rows: 2,
    fill: "row"
  },
  pagination: {
    el: ".swiper-pagination-memberships",
    clickable: true,
  },
  breakpoints: {
    350: {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      grid: {
        rows: 2,
        fill: "row"
      },
    },
    640: {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      grid: {
        rows: 2,
        fill: "row"
      },
    },
    768: {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      grid: {
        rows: 2,
        fill: "row"
      },
    },
    950: {
      slidesPerView: 2.65,
      slidesPerGroup: 2,
      spaceBetween: 20,
      grid: {
        rows: 2,
        fill: "row"
      },
    },
    1024: {
      slidesPerView: 2.65,
      slidesPerGroup: 2,
      spaceBetween: 20,
      grid: {
        rows: 2,
        fill: "row"
      },
    },
    1280: {
      slidesPerView: 2.65,
      slidesPerGroup: 2,
      spaceBetween: 20,
      grid: {
        rows: 2,
        fill: "row"
      },
    },
  }
});
